import {
  CALLBACK_TYPE_GET_LIST_ORDERS,
  CALLBACK_TYPE_GET_ORDERS_DETAIL,
  CALLBACK_TYPE_GET_USER_PROFILE,
  CALLBACK_TYPE_LIST_USER_RESERVATION,
  CALLBACK_TYPE_GET_VIEWED_HOTELS,
  CALLBACK_TYPE_ADD_VIEWED_HOTEL,
  CALLBACK_TYPE_GET_UPLOAD_IMAGE_URL,
  CALLBACK_TYPE_DELETE_IMAGE,
  CALLBACK_TYPE_UPDATE_PRODUCT,
  CALLBACK_TYPE_UPDATE_USER_PROFILE,
  CALLBACK_TYPE_UPDATE_USER_PASSWORD,
  CALLBACK_TYPE_GET_URL_UPLOAD,
  CALLBACK_TYPE_UPDATE_USER_AVATAR_PROFILE,
  CALLBACK_TYPE_USER_POST_REVIEW,
  CALLBACK_TYPE_USER_BANK_INFO,
  CALLBACK_TYPE_USER_WITHDRAW,
  CALLBACK_TYPE_USER_LIST_ORDERS,
  CALLBACK_TYPE_USER_LIST_ORDERS_V2,
  LINK_SOCIAL_NETWORK,
  UNLINK_SOCIAL_NETWORK,
  CREATE_SELLER_REVIEW,
} from "../interfaces/CallbackType";
import axiosInstance from "./axios";

const getListOrders = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_LIST_ORDERS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getOrderDetail = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_ORDERS_DETAIL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getProfile = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_USER_PROFILE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListReservationByUserLogged = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_LIST_USER_RESERVATION,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getViewedHotels = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_VIEWED_HOTELS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const addViewedHotel = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_ADD_VIEWED_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPresignedUploadImageUrl = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_UPLOAD_IMAGE_URL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const deleteImage = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_DELETE_IMAGE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const update_product = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_UPDATE_PRODUCT,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const update_user_profile = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_UPDATE_USER_PROFILE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const update_user_password = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_UPDATE_USER_PASSWORD,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const upload = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_URL_UPLOAD,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const update_user_avatar_profile = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_UPDATE_USER_AVATAR_PROFILE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const post_new_review_hotel = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_USER_POST_REVIEW,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const update_user_bank_info = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_USER_BANK_INFO,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_withdraw_amount = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_USER_WITHDRAW,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_get_list_orders = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_USER_LIST_ORDERS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_get_list_orders_v2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_USER_LIST_ORDERS_V2,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const link_social_network = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: LINK_SOCIAL_NETWORK,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const unlink_social_network = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: UNLINK_SOCIAL_NETWORK,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const create_seller_review = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/authed", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CREATE_SELLER_REVIEW,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const AuthedServices = {
  getOrderDetail,
  getListOrders,
  getProfile,
  getListReservationByUserLogged,
  getViewedHotels,
  addViewedHotel,
  getPresignedUploadImageUrl,
  deleteImage,
  update_product,
  update_user_profile,
  update_user_password,
  upload,
  update_user_avatar_profile,
  post_new_review_hotel,
  update_user_bank_info,
  user_withdraw_amount,
  user_get_list_orders,
  user_get_list_orders_v2,
  link_social_network,
  unlink_social_network,
  create_seller_review,
};

export default AuthedServices;
